import React, { useState } from "react";
import {
  Box,
  Paper,
  Tab,
  Tabs,
  styled,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@mui/icons-material/Add";
import {
  useGetCapabilitiesQuery,
  useProductQuery,
  useSaveCapabilityMutation,
} from "../../useQuery";
import useAddAppDetails from "../../useQuery/useAddAppDetails";
import { useLocation } from "react-router-dom";
import CapabilitiesManager from "./CapabilitiesManager";
import AppVersionManager from "./AppVersionManager";
import { useNotification } from "../../hooks";

const StyledCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0px 43px 62.4px 0px rgba(0, 0, 0, 0.09)",
  borderTop: "2px solid #2550d1",
  overflow: "hidden",
}));

const MobileConfiguration = () => {
  const path = useLocation().pathname;
  const notify = useNotification()

  const [activeTab, setActiveTab] = useState(0);




  const { data: products } = useProductQuery();
  const { data: savedCapabilities, refetch: refetchCapabilities } = useGetCapabilitiesQuery();
  const saveCapabilityMutation = useSaveCapabilityMutation({
    onSuccess: (data) => {
      refetchCapabilities();
      notify("Capability saved successfully!", "success")
    },
    onError: (error) => {
      notify("Failed to save capability", "error")
    },
  });


  const addAppDetailsMutation = useAddAppDetails({
    onSuccess: (data) => {
      notify("App version created successfully!", "success")
     
    },
    onError: (error) => {
      notify("Failed to create app version", "error")
    },
  });


  const handleSaveCapability = async (capabilityData) => {
    await saveCapabilityMutation.mutateAsync(capabilityData);
  };

  const handleCreateAppVersion = async (appVersionData) => {
    await addAppDetailsMutation.mutateAsync(appVersionData);
  };

  return (
    <Box sx={{ py: 4 }}>



      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 500,
              py: 2,
            },
            "& .Mui-selected": { color: "#2550d1" },
            "& .MuiTabs-indicator": { backgroundColor: "#2550d1", height: 3 },
          }}
        >
          <Tab label="Device Capabilities" icon={<SettingsIcon />} iconPosition="start" />
          <Tab label="App Versions" icon={<AddIcon />} iconPosition="start" />
        </Tabs>
      </Box>


      {activeTab === 0 && (
        <StyledCard>
          <Box sx={{ p: 3 }}>
            <CapabilitiesManager
              savedCapabilities={savedCapabilities || []}
              onSaveCapability={handleSaveCapability}
          
             
              isSaving={saveCapabilityMutation.isPending}
              onRefetchCapabilities={refetchCapabilities}
            />
          </Box>
        </StyledCard>
      )}

      {activeTab === 1 && (
        <StyledCard>
          <Box sx={{ p: 3 }}>
            <AppVersionManager
              products={products || []}
              onCreateAppVersion={handleCreateAppVersion}
           
              isCreating={addAppDetailsMutation.isPending}
            />
          </Box>
        </StyledCard>
      )}



    </Box>
  );
};

export default MobileConfiguration; 